import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserRole } from '../lib/types/auth';

/**
 * Component that redirects users to their role-specific landing page
 * This is used for the root "/" route to send users to the appropriate page
 */
export const RoleBasedRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && currentUser) {
      // Redirect Influencer role to affiliate orders page
      if (currentUser.roles?.includes(UserRole.Influencer)) {
        navigate('/affiliate-orders', { replace: true });
      }
    }
  }, [currentUser, loading, navigate]);

  // If user is Influencer, don't render children (they'll be redirected)
  if (currentUser?.roles?.includes(UserRole.Influencer)) {
    return null;
  }

  // For other roles, render the Dashboard
  return <>{children}</>;
};

